import React, { useCallback } from 'react';

import { QToggleButton, QToggleButtonGroup } from '@captivateiq/quotient';

import type { ReasoningEffort } from '../config/modelConfig';
import { EFFORT_OPTIONS } from '../config/modelConfig';

type EffortSelectorProps = {
  selectedEffort: ReasoningEffort;
  onEffortChange: (effort: ReasoningEffort) => void;
};

const EFFORT_LABELS: Record<ReasoningEffort, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

export const EffortSelector = ({ selectedEffort, onEffortChange }: EffortSelectorProps) => {
  const handleChange = useCallback(
    (_event: React.MouseEvent<HTMLElement>, value: string | null) => {
      if (value) {
        onEffortChange(value as ReasoningEffort);
      }
    },
    [onEffortChange],
  );

  return (
    <QToggleButtonGroup
      data-testid="effort-selector"
      exclusive
      size="small"
      value={selectedEffort}
      onChange={handleChange}
    >
      {EFFORT_OPTIONS.map((effort) => (
        <QToggleButton data-testid={`effort-option-${effort}`} key={effort} value={effort}>
          {EFFORT_LABELS[effort]}
        </QToggleButton>
      ))}
    </QToggleButtonGroup>
  );
};
